<template>
  <el-table
    :data="productsData"
    class="table-content rounded-xl w-full"
    header-cell-class-name="custom-table__header-cell"
    cell-class-name="custom-table__cell"
    border
    :empty-text="$t('empty')"
    ref="tableRef"
    @sort-change="handleSortChange"
  >
    <el-table-column
      v-for="col in tableColumns"
      :key="col.prop"
      :prop="col.prop"
      :label="col.label"
      :min-width="20"
      :width="col.width"
      :sortable="col.sortable"
    >
      <template v-slot="scope">
        {{ scope.row[col.prop] }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { IMarumiyaProduct } from '@/utils/types/model/marumiyaProduct'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  width?: number
}

@Options({
  name: 'ProductList',
  emits: ['sort-change'],
})
export default class ProductList extends Vue {
  @Prop({ type: Array, default: () => [] }) productsData!: IMarumiyaProduct[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'itemCode', label: this.$t('item_code'), sortable: 'custom' },
      { prop: 'itemName', label: this.$t('item_name'), sortable: 'custom' },
      { prop: 'stockUnit', label: this.$t('stock_unit') },
      { prop: 'storageUnit', label: this.$t('storage_unit') },
      { prop: 'companyCode', label: this.$t('company_code'), width: 150 },
    ]
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
</script>
